import { useMemo } from 'react';
import { useMutation, QueryOptions } from 'react-query';
import moment from 'moment';

import AffordableReportService from '../../services/affordableReportService';

const useGenerateProjectWorksheetReport = ({
  organizationId,
  propertyId,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  options?: QueryOptions,
}) => {
  const service = useMemo(() => new AffordableReportService(), []);

  const mutation = useMutation(
    async (values) => {
      const fileName = `RD_Project_Worksheet_${moment().unix()}.pdf`;
      return service.generateRDProjectWorksheet(
        organizationId,
        propertyId,
        values.date,
        fileName,
      );
    },
    {
      ...options,
    },
  );
  return mutation;
};

export default useGenerateProjectWorksheetReport;
